module.exports = __webpack_public_path__ + "static/media/add-contact-center.dbf4d2e2.svg";